var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge font-size-13",class:_vm.badgeColor(this.type, this.status)},[_vm._v(" "+_vm._s(_vm.statusLabel(this.status))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }